declare namespace NodeJS {
  interface ProcessEnv {
    API_BASE_URL: string | undefined;
  }
}

let processApiBaseUrl: string | undefined;
try {
  processApiBaseUrl = process.env.API_BASE_URL;
} catch (e) {}

const rawImportMetaEnv =
  typeof import.meta !== "undefined" && (import.meta as any)?.env
    ? ((import.meta as any).env as Record<string, string | undefined>)
    : undefined;

const configuredBaseUrl = (
  processApiBaseUrl ??
  rawImportMetaEnv?.API_BASE_URL ??
  ""
).trim();

const API_BASE_URL = configuredBaseUrl.length > 0 ? configuredBaseUrl : "";

function resolveApiUrl(path: string): string {
  if (!API_BASE_URL) return path;
  return new URL(path, API_BASE_URL).toString();
}

export class ApiError extends Error {
  readonly status: number;
  readonly serverError: string | null;
  readonly serverMessage: string | null;
  readonly payload: Record<string, unknown>;

  constructor(status: number, payload: Record<string, unknown> = {}) {
    const serverError =
      typeof payload.error === "string" && payload.error.trim().length > 0
        ? payload.error.trim()
        : null;
    const serverMessage =
      typeof payload.message === "string" && payload.message.trim().length > 0
        ? payload.message.trim()
        : null;
    super(serverError || `HTTP ${status}`);
    this.name = "ApiError";
    this.status = status;
    this.serverError = serverError;
    this.serverMessage = serverMessage;
    this.payload = payload;
  }
}

export class ApiNetworkError extends Error {
  constructor() {
    super("Network request failed.");
    this.name = "ApiNetworkError";
  }
}

export async function api<T = any>(
  path: string,
  opts: RequestInit = {},
  token?: string | null
): Promise<T> {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...(opts.headers as Record<string, string> | undefined),
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const url = resolveApiUrl(path);
  let res: Response;
  try {
    res = await fetch(url, {
      ...opts,
      headers,
    });
  } catch (error) {
    if (error instanceof TypeError) {
      throw new ApiNetworkError();
    }
    throw error;
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const payload = (data && typeof data === "object" ? (data as Record<string, unknown>) : undefined) || {};
    throw new ApiError(res.status, payload);
  }
  return data as T;
}
